import { Component, inject } from '@angular/core';
import { RolesService } from '../../../core/services/roles/roles.service';
import { UiChannelService } from '../../../core/services/ui-channel/ui-channel.service';

/**
 * Rolle, die den Umschalter freischaltet (#837). Ohne sie gibt es weder Knopf noch Wechsel.
 */
export const UI_CHANNEL_SWITCH_ROLE = 'framework_nexato_employee';

/**
 * Umschalter zwischen der klassischen (4.x) und der neuen (5.x) Oberfläche (#741).
 *
 * Sitzt in der rechten Toolbar-Zone und rendert nur, wenn das Deployment dafür
 * konfiguriert ist und der Nutzer die Rolle framework_nexato_employee hat (#837) —
 * fehlende Konfiguration oder Rolle blendet aus, statt zu deaktivieren. Ein
 * Feature-Flag spielt dafür keine Rolle mehr.
 *
 * Die Komponente ist wertgesteuert und trägt keine Annahme über die Version, die
 * sie anzeigt: welchen Kanal sie ausliefert, sagt ihr ausschliesslich die ENV.
 * Derselbe Code läuft deshalb auf 5.x mit umgekehrter Beschriftung.
 *
 * Nicht standalone, weil nx-default-button auf dieser Release-Linie ebenfalls
 * NgModule-gebunden ist — die Komponente wird von SharedModule deklariert, wo der
 * Button ohnehin zur Verfügung steht. Die Rollenprüfung sitzt hier und nicht im
 * UiChannelService: RolesService ist auf dieser Linie nicht im Root-Injektor
 * registriert, sondern über CoreModule.
 *
 * Die Beschriftung wird als roher i18n-Schlüssel durchgereicht — nx-default-button
 * übersetzt sein label selbst.
 */
@Component({
  selector: 'app-ui-channel-switch',
  template: `
    @if (showSwitch) {
      <nx-default-button
        [label]="label"
        [icon]="'icon-switch'"
        (clicked)="onSwitch()">
      </nx-default-button>
    }
  `,
})
export class UiChannelSwitchComponent {

  readonly uiChannel = inject(UiChannelService);
  private readonly rolesService = inject(RolesService);

  get showSwitch(): boolean {
    return this.uiChannel.available && this.rolesService.hasRole(UI_CHANNEL_SWITCH_ROLE);
  }

  get label(): string {
    return this.uiChannel.current === 'next'
      ? 'layoutComponent.uiChannel.switchToStable'
      : 'layoutComponent.uiChannel.switchToNext';
  }

  onSwitch(): void {
    const target = this.uiChannel.other;
    if (target && this.showSwitch) {
      this.uiChannel.switchTo(target);
    }
  }
}
